module.exports = __webpack_public_path__ + "img/New_DeliveryB2B__Branco_Vertical.7f3d3dd3.png";